export default __webpack_public_path__ + "static/media/Leg Lower Right.572c61d9.jpg";